import React, { Component, type ReactNode, type ComponentType } from 'react';
import type { Store, Reducer, Middleware } from 'redux';
import type { Epic } from 'redux-observable';
import AppBase from '@atlassian/jira-app-base';
import AppStyle from '@atlassian/jira-common-components-app-style';
import type { BaseState } from '@atlassian/jira-servicedesk-common/src/model/types';
import { withExtraMiddleware } from '@atlassian/jira-servicedesk-common/src/redux/extra-middleware';
import { ServiceDeskErrorBoundary } from '@atlassian/jira-servicedesk-common/src/ui/components/servicedesk-error-boundary';
import { createStore } from '@atlassian/jira-servicedesk-common/src/ui/components/servicedesk-subapp-base/create-store/index.tsx';
import type { AppName } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import LegacyAutomationModules from '../legacy-automation-modules';

export type AutomationAppBaseProps = {
	appName: AppName;
	initialState: BaseState;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	rootReducer: Reducer<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	rootEpic: Epic<any, any>;
	children: ReactNode | null;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ErrorView?: ComponentType<Record<any, any>>;
	loadLegacyModules: boolean;
	onErrorHandler: (arg1: string | Error) => void;
};

type Props = AutomationAppBaseProps & {
	extraMiddleware: Middleware[];
};

// eslint-disable-next-line jira/react/no-class-components
export class AutomationAppBaseView extends Component<Props> {
	constructor(props: Props) {
		super(props);

		this.store = createStore(
			this.props.appName,
			this.props.initialState,
			this.props.rootReducer,
			this.props.extraMiddleware,
			this.props.rootEpic,
		);
	}

	shouldComponentUpdate(nextProps: Props): boolean {
		const { appName, rootReducer, rootEpic, children, extraMiddleware, onErrorHandler } =
			this.props;

		// If any prop other than initialState has changed
		return (
			appName !== nextProps.appName ||
			rootReducer !== nextProps.rootReducer ||
			rootEpic !== nextProps.rootEpic ||
			children !== nextProps.children ||
			extraMiddleware !== nextProps.extraMiddleware ||
			onErrorHandler !== nextProps.onErrorHandler
		);
	}

	store: Store<BaseState>;

	render() {
		const { children, appName, loadLegacyModules, onErrorHandler, ErrorView } = this.props;
		// We put the error boundary below <AppBase>, to intercept errors before the error boundary
		// provided by AppBase
		return (
			<AppBase store={this.store}>
				<AppStyle>
					<ServiceDeskErrorBoundary
						appName={appName}
						// @ts-expect-error - TS2322 - Type '(arg1: string | Error) => void' is not assignable to type '(arg1: string | Error) => undefined'.
						onErrorHandler={onErrorHandler}
						ErrorView={ErrorView}
					>
						{loadLegacyModules ? (
							<LegacyAutomationModules>{children}</LegacyAutomationModules>
						) : (
							children
						)}
					</ServiceDeskErrorBoundary>
				</AppStyle>
			</AppBase>
		);
	}
}

export default withExtraMiddleware(AutomationAppBaseView);
